import styled from "@emotion/styled";
import { Button } from "@silvertours/front-shared";
import Checked from "@engineering/icons/checked";
var SwirlWrapper = /*#__PURE__*/ styled("div", {
    target: "e79jzxi0"
})("display:none;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:block;position:absolute;top:30px;left:-170px;width:550px;height:113px;transform:rotate(-20deg);}");
var StyledForm = /*#__PURE__*/ styled("form", {
    target: "e79jzxi1"
})("display:flex;flex-direction:column;padding:0 ", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var TitleWrapper = /*#__PURE__*/ styled("div", {
    target: "e79jzxi2"
})("button{position:absolute;top:1rem;right:1rem;margin:0;padding:0;border:0;appearance:none;background:none;cursor:pointer;}");
var Title = /*#__PURE__*/ styled("p", {
    target: "e79jzxi3"
})("margin:0 0 1rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:normal;font-size:1.25rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";text-align:left;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin:0 0 2rem;padding-top:140px;font-size:1.5rem;text-align:center;}");
var FormActionArea = /*#__PURE__*/ styled("div", {
    target: "e79jzxi4"
})("display:flex;justify-content:center;padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
var MaxWidthWrapper = /*#__PURE__*/ styled("div", {
    target: "e79jzxi5"
})("max-width:455px;width:100%;");
var InputWrapper = /*#__PURE__*/ styled("div", {
    target: "e79jzxi6"
})("margin-bottom:1rem;");
var PasswordLostWrapper = /*#__PURE__*/ styled("p", {
    target: "e79jzxi7"
})("margin:-0.75rem 1rem 1rem;font-size:0.875rem;text-align:right;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin:1rem 0 2rem;font-size:1rem;text-align:left;}");
var SubmitButton = /*#__PURE__*/ styled(Button, {
    target: "e79jzxi8"
})(function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin:0 auto;padding-left:3rem;padding-right:3rem;width:auto;}");
var Footer = /*#__PURE__*/ styled("div", {
    target: "e79jzxi9"
})("padding:1rem;text-align:center;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural20;
}, ";");
var CheckIcon = /*#__PURE__*/ styled(Checked, {
    target: "e79jzxi10"
})("margin-left:0.5em;width:1rem;height:1rem;fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";vertical-align:middle;");
export { CheckIcon, Footer, FormActionArea, InputWrapper, MaxWidthWrapper, PasswordLostWrapper, StyledForm, SubmitButton, SwirlWrapper, Title, TitleWrapper };
